export interface ProfileData {
  first_name: string;
  last_name: string;
  age: number | null;
  height_cm: number | null;
  current_weight_kg: number | null;
  weight_goal_kg: number | null;
  fitness_level: 'beginner' | 'intermediate' | 'advanced';
  primary_goals: string[];
  experience_level: 'new' | 'returning' | 'experienced';
  phone: string;
  emergency_contact: string;
}

export const fitnessGoals = [
  'Weight Loss',
  'Muscle Gain',
  'Endurance',
  'Strength',
  'Flexibility',
  'General Health',
  'Marathon Training',
  'Body Composition',
];